import { MdPreview } from 'md-editor-rt';
import React from 'react';
import { StorageService } from '../services/StorageService';
import { StorageCacheService } from '../services/StorageCacheService';
import { Container, Center, Spinner, Box } from '@chakra-ui/react';
import { ErrorMessage } from '../components/ErrorMessage';
import { AppContext } from './AppContext';
import { useScrollPosition } from '../hooks/useScrollPosition';

export const MarkdownBlock = (props: {
  templateId: string
}) => {

  const { restoreScrollPosition } = useScrollPosition(props.templateId || 'default');

  const { isAuthenticated } = React.useContext(AppContext);
  const [errorMessage, setErrorMessage] = React.useState<any>();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const [md, setMd] = React.useState<string>('');

  React.useEffect(() => {
    setErrorMessage(undefined);
    const templateKey = `template:${props.templateId}`;
    if (props.templateId) {
      const cached = StorageCacheService.getValue<string>(templateKey);
      if (cached) {
        setMd(cached);
        setTimeout(restoreScrollPosition, 50);
      } else {
        setIsLoading(true);
        StorageService.getPageFile(props.templateId).then(templateMd => {
          StorageCacheService.setValue(templateKey, templateMd);
          setMd(templateMd)
          setTimeout(restoreScrollPosition, 50);
        }).catch(err => {
          setErrorMessage(err);
        }).finally(() => {
          setIsLoading(false);
        });
      }
    }
  }, [isAuthenticated, props.templateId, restoreScrollPosition]);


  return <>
    <Box mt={4}>
      <ErrorMessage error={errorMessage} />
    </Box>
    {isLoading
      ? <Container mt={200}><Center color='fg.muted' fontSize='large'><Spinner size='lg' /><Box ml={4} >Loading page...</Box></Center></Container>
      : <MdPreview value={md} />
    }
  </>;
}